import { Button } from "@mui/material";
import { AI_ASSISTANT_DISABLED_MESSAGE } from "../../AiToolboxSection.constants";
import { isForbiddenError } from "../../AiToolboxSection.stream";

type AiAssistantStreamErrorProps = {
  error: Error;
  isLoading: boolean;
  retryLast: () => void;
};

export default function AiAssistantStreamError({
  error,
  isLoading,
  retryLast,
}: AiAssistantStreamErrorProps) {
  const isAssistantDisabled = isForbiddenError(error);

  const handleRetryError = () => {
    if (isLoading) return;
    retryLast();
  };

  return (
    <div className="px-3 mt-2 py-2 mb-2 text-sm text-error-main dark:text-error-dark bg-error-light rounded flex items-center gap-3">
      <span className="flex-1">
        {isAssistantDisabled
          ? AI_ASSISTANT_DISABLED_MESSAGE
          : (error.message ?? "Unknown error")}
      </span>
      {!isAssistantDisabled && (
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={handleRetryError}
          disabled={isLoading}
          className="px-3 py-1 text-xs font-medium text-error-main dark:text-error-dark border disabled:opacity-50 disabled:cursor-not-allowed"
          data-ph-capture-attribute-action="retry_ai_error"
        >
          Retry
        </Button>
      )}
    </div>
  );
}
